module.exports = __webpack_public_path__ + "static/media/footer.ea7369ea.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/footer.scss
// module id = 1425
// module chunks = 0